import { z } from 'zod';
import { baseScheme, baseSchemeDefaultValue, firstNameScheme, lastNameScheme } from './baseScheme';
import { InviteFlowFields } from '../../../consts';

export const adminScheme = baseScheme.extend({
  ...firstNameScheme.shape,
  ...lastNameScheme.shape,
  [InviteFlowFields.APPOINT_ADMIN]: z.boolean().refine((v) => v),
  [InviteFlowFields.ADMIN_CORPORATE_RESOLUTION]: z.boolean().refine((v) => v),
});

export const adminSchemeDefaultValue = {
  ...baseSchemeDefaultValue,
  [InviteFlowFields.ADMIN_CORPORATE_RESOLUTION]: false,
  [InviteFlowFields.APPOINT_ADMIN]: false,
};
